import React from 'react';
import { Text } from '../../../../atoms';
import './style.scss';

export const EmptyStateMessage: React.FC = () => {
  return (
    <div className="impact-evaluation-empty__container">
      <div className="impact-evaluation-empty__title-section">
        <Text component="h3" text="Nenhuma avaliação de impacto disponível" />
      </div>
      <div className="impact-evaluation-empty__description">
        <Text 
          component="p" 
          text="As avaliações de impacto ficam disponíveis apenas para treinamentos concluídos com sucesso."
        />
        <Text 
          component="p" 
          text="Complete seus treinamentos para ter acesso às avaliações de impacto."
        />
      </div>
    </div>
  );
};

export default EmptyStateMessage;
